<table mat-table fixedLayout [dataSource]="emptyTable" class="!bg-transparent w-[1300px]">
  @for (displayedColumn of displayedColumns(); track $index) {
    <ng-container matColumnDef="{{displayedColumn}}">
      <th mat-header-cell *matHeaderCellDef class="">{{displayedColumn | transformUnderscoreToSpace | titlecase}}</th>
      <td *matCellDef="let element" mat-cell class="">
        <span [style]="`width: ${getWidth(displayedColumn)}px;`" [class]="'block min-h-[20px] bg-[#D9D9D9]/30 rounded-[5px] w-[' + getWidth(displayedColumn) + 'px]'"></span>
      </td>
    </ng-container>
  }

  <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns()"
    class="[&>th]:!bg-aml-gray-250/40 text-aml-green-700 rounded-[7px]
      first:[&>th]:pl-[22px] [&>th]:text-aml-green-700/40 [&>th]:!border-none !font-base
      !h-auto [&>th]:h-[30px] [&>th]:px-[10px] first:[&>th]:rounded-l-[7px] last:[&>th]:rounded-r-[7px]"
  >
  </tr> -->
  <tr mat-row *matRowDef="let element; columns:displayedColumns()"
    class="
      first:[&>td]:pl-[22px] [&>td]:px-[10px] !bg-white hover:!bg-gray-50/30
      cursor-pointer shadow-table-row rounded-[6px] !h-[60px] !font-base"
  >
  </tr>
</table>
